module.exports = __webpack_public_path__ + "static/media/pdf.56a70ac3.svg";